import { render, staticRenderFns, recyclableRender, components } from "./merchantApproveFail.vue?vue&type=template&id=678e23c8&scoped=true&"
var renderjs
import script from "./merchantApproveFail.vue?vue&type=script&lang=js&"
export * from "./merchantApproveFail.vue?vue&type=script&lang=js&"
import style0 from "./merchantApproveFail.vue?vue&type=style&index=0&id=678e23c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e23c8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/applyMerchant/merchantApproveFail.vue"
export default component.exports